var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-list',{attrs:{"data-url":"/api/v1/user","data-size":"10","data-headers":_vm.tHeaders,"edit-route":"/master/user/add","delete-endpoint":"/api/v1/user","deleteReason":true,"title":"User List"}})}
var staticRenderFns = []

export { render, staticRenderFns }